import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { label: '恋爱漫画', path: '/category/romance' },
      { label: '奇幻漫画', path: '/category/fantasy' },
      { label: '动作漫画', path: '/category/action' },
      { label: '恐怖漫画', path: '/category/horror' },
    ],
  },
  {
    title: '快速链接',
    links: [
      { label: '排行榜', path: '/category/ranking' },
      { label: '最新更新', path: '/category/latest' },
      { label: '专题推荐', path: '/category/featured' },
      { label: '全部漫画', path: '/category/all' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '用户口碑', path: '/about#testimonials' },
      { label: '联系我们', path: '/about#contact' },
      { label: '隐私政策', path: '/about#privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900" role="contentinfo">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="lg:w-1/3">
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl text-background-50">
                  虚空韩漫
                </span>
              </Link>
              <p className="text-background-400 text-sm leading-relaxed max-w-xs">
                虚空韩漫网致力于为华语读者提供最优质的韩漫在线阅读体验。无删减、免费、每日更新，让每一部韩国漫画展现原汁原味的魅力。
              </p>
            </div>

            <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
              {footerLinks.map((group) => (
                <div key={group.title}>
                  <h3 className="text-background-200 text-sm font-medium mb-4">
                    {group.title}
                  </h3>
                  <ul className="flex flex-col gap-2.5">
                    {group.links.map((link) => (
                      <li key={link.label}>
                        <Link
                          to={link.path}
                          className="text-background-400 hover:text-background-200 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <p className="text-background-500 text-xs">
                &copy; {new Date().getFullYear()} 虚空韩漫网. All rights reserved.
              </p>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-background-600" />
              <p className="text-background-500 text-xs">
                本站内容仅供学习交流，请支持正版漫画
              </p>
            </div>

            <div className="flex items-center gap-4">
              <a
                href="#"
                className="text-background-500 hover:text-background-300 transition-colors cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="text-background-500 hover:text-background-300 transition-colors cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="text-background-500 hover:text-background-300 transition-colors cursor-pointer"
                aria-label="QQ"
                rel="nofollow"
              >
                <i className="ri-qq-line text-lg"></i>
              </a>
              <a
                href="#"
                className="text-background-500 hover:text-background-300 transition-colors cursor-pointer"
                aria-label="B站"
                rel="nofollow"
              >
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}